import {Component} from '@angular/core';

@Component({
  selector: 'date-ico',
  templateUrl: './date-ico.component.html'
})
export class DateIcoComponent {
}
